import { CreateInvoiceDto } from "@/core/features/invoice/create-invoice.dto";
import { Expose, Transform } from "class-transformer";
import { toCents } from "@/utils/numberUtils";

export class CreateAndLinkInvoiceDto extends CreateInvoiceDto {
  @Expose()
  certificationId: string;

  @Expose()
  @Transform(({ value }) => toCents(value))
  allocatedAmount: number;
}
